var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.3155,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7524 8.59134H11.7648C9.83523 8.59134 8.271 10.1545 8.271 12.0827V19.0655C8.271 20.9937 9.83523 22.5569 11.7648 22.5569H18.7524C20.682 22.5569 22.2462 20.9937 22.2462 19.0655V12.0827C22.2462 10.1545 20.682 8.59134 18.7524 8.59134ZM15.5959 13.4718C15.1597 13.4071 14.7143 13.4816 14.3229 13.6845C13.9315 13.8875 13.6141 14.2085 13.4159 14.6021C13.2177 14.9957 13.1487 15.4417 13.2187 15.8767C13.2888 16.3118 13.4943 16.7136 13.8061 17.0252C14.1179 17.3368 14.52 17.5422 14.9553 17.6122C15.3907 17.6822 15.837 17.6132 16.2308 17.4151C16.6247 17.217 16.946 16.8999 17.1491 16.5087C17.3522 16.1176 17.4267 15.6725 17.362 15.2367C17.296 14.7921 17.0887 14.3805 16.7707 14.0627C16.4527 13.7449 16.0408 13.5377 15.5959 13.4718ZM13.6792 12.4449C14.3315 12.1067 15.0739 11.9826 15.8009 12.0903C16.5424 12.2002 17.2288 12.5455 17.7589 13.0752C18.2889 13.6048 18.6344 14.2908 18.7444 15.0318C18.8522 15.7582 18.728 16.5001 18.3896 17.152C18.0511 17.8038 17.5156 18.3324 16.8592 18.6626C16.2027 18.9927 15.4589 19.1076 14.7333 18.991C14.0078 18.8743 13.3375 18.532 12.8179 18.0127C12.2983 17.4934 11.9557 16.8236 11.8389 16.0986C11.7222 15.3736 11.8372 14.6302 12.1676 13.9742C12.498 13.3183 13.0269 12.7831 13.6792 12.4449ZM19.1006 11.0354C18.7149 11.0354 18.4023 11.348 18.4023 11.7336C18.4023 12.1193 18.7149 12.4319 19.1006 12.4319H19.1075C19.4932 12.4319 19.8058 12.1193 19.8058 11.7336C19.8058 11.348 19.4932 11.0354 19.1075 11.0354H19.1006Z",
    fill: "#052142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaLogo);
export default __webpack_public_path__ + "static/media/insta_logo.5ad23915ab68b310362f0e5f6f226864.svg";
export { ForwardRef as ReactComponent };